import { useEffect, useState } from 'react'

import { useCaptureEvent } from '#/hooks'

import { Overview } from './overview'
import { Result } from './result'
import s from './tabs.module.scss'

const tabs = [
  {
    name: 'overview',
    label: 'Overview',
    content: <Overview />,
  },
  {
    name: 'result',
    label: 'Result',
    content: <Result />,
  },
  {
    name: 'submission',
    label: 'Submission',
    href: '/axie-game-jam/2023/submissions',
  },
]

export const Tab = () => {
  const [tab, setTab] = useState(() => {
    const hash = window.location.hash.replace(/^#/, '')
    if (hash === 'overview' || hash === 'result') {
      return hash
    }

    return 'overview'
  })
  const captureEvent = useCaptureEvent()

  useEffect(() => {
    window.onhashchange = () => {
      const hash = window.location.hash.replace(/^#/, '')
      if (hash === 'overview' || hash === 'result') {
        setTab(hash)
      }
    }
  }, [])

  useEffect(() => {
    window.location.hash = tab
  }, [tab])

  return (
    <div className={s.container}>
      <div className={s.tabs}>
        {tabs.map((item) => (
          <button
            className={s.tab}
            key={item.name}
            title={item.label}
            data-active={tab === item.name}
            onClick={() => {
              if (item.href) {
                window.location.href = item.href
              } else {
                setTab(item.name)
              }
              captureEvent('Click AGJ tab ' + item.name)
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div className={s.content}>
        {tabs.find((item) => item.name === tab)?.content}
      </div>
    </div>
  )
}
